import clsx from "clsx";

import { FormattedControl } from "@/components/FormattedControl";

type Props = {
	classNames?: string;
	minAge: string;
	handleChangeMinAge: (youngerAge: string) => void;
	maxAge: string;
	handleChangeMaxAge: (olderAge: string) => void;
};

export function AgeGroup({
	classNames,
	minAge,
	handleChangeMinAge,
	maxAge,
	handleChangeMaxAge,
}: Props) {
	return (
		<div className={clsx(classNames)}>
			<label title="Faixa etária" className="form-label" htmlFor="age-group">
				Faixa etária
			</label>

			<div className="d-flex gap-2">
				<div className="d-flex gap-2">
					<FormattedControl
						id="age-group"
						type="number"
						placeholder="min"
						min={0}
						value={minAge}
						onChange={(event) => handleChangeMinAge(event.currentTarget.value)}
					/>

					<FormattedControl
						type="number"
						placeholder="max"
						min={Number(minAge)}
						value={maxAge}
						onChange={(event) => handleChangeMaxAge(event.currentTarget.value)}
					/>
				</div>
			</div>
		</div>
	);
}
